import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPath } from "../lib/url";

// POST /api/logout, then bounce to the login screen.
export default function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await fetch(apiPath("/api/logout"), { method: "POST" });
      } catch {
        // swallow — best effort
      }
      navigate("/", { replace: true });
    })();
  }, [navigate]);
  return <div className="batch-shell"><div className="loading">Signing out…</div></div>;
}
